import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  QueryInput_DirectoryController_GetRecords_SchemaName,
  QueryInput_DirectoryController_GetRecords_Status,
  useDirectoryGetRecordsQuery,
} from 'api/generated/graphql';
import { parseDirectoryRecordData, useError } from 'api/helpers';
import {
  DirectoryRecordData,
  ListData,
  ListDataQueryFunction,
} from 'api/types/data';
import { lodash } from 'helpers';

export const useDirectoryGetRecords: ListDataQueryFunction<
  DirectoryRecordData,
  {
    directorySchemaName: string;
    search?: string;
  },
  any,
  { fields?: string }
> = ({ pagination, filter, params }) => {
  const {
    loading,
    error: apolloError,
    data,
  } = useDirectoryGetRecordsQuery({
    variables: {
      limit: pagination.limit,
      page: pagination.page + 1,
      schemaName:
        filter?.directorySchemaName as QueryInput_DirectoryController_GetRecords_SchemaName,
      search: filter?.search?.toString() || undefined,
      status: QueryInput_DirectoryController_GetRecords_Status.Active,
      fields: params?.fields,
    },
  });

  const error = useError(apolloError);

  const listData: ListData<DirectoryRecordData> | undefined = useMemo(
    () =>
      data?.directoryRecords
        ? {
            total: data?.directoryRecords?.total,
            list: lodash
              .compact(data?.directoryRecords?.list)
              .map(parseDirectoryRecordData),
          }
        : undefined,
    [data?.directoryRecords]
  );

  return {
    listData,
    loading,
    error,
  };
};
